module.exports = __webpack_public_path__ + "static/img/image6.31a9a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image6.png
// module id = voUp
// module chunks = 0